import React from 'react'
import data from './data.json'
import { Intro, Layout, Header, SectionTitle } from '../../../../components'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        //state="design" disabling switcher
        title={data.title}
      />
      <Layout
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      >
        <Intro>
          <p>
            People trust predictable content. Keeping word use, spelling,
            capitalization and abbreviations consistent helps build a common
            language.
          </p>

          <p>
            All proper nouns, including Wilmington Trust product names, will
            always be capitalized. Features and products that aren't unique to
            Wilmington Trust are not capitalized unless otherwise noted here.
          </p>
        </Intro>
        <SectionTitle>A: account...</SectionTitle>
        <h3 class="c-title-3--normal">account</h3>
        <p>Lowercase, unless the word is part of a formal product name</p>
        <SectionTitle>B: bank, branch...</SectionTitle>
        <h3 class="c-title-3--normal">bank</h3>
        <p>Lowercase, unless preceded by M{'&'}T</p>
        <h3 class="c-title-3--normal">branch</h3>
        <p>Always use branch, not office</p>

        <SectionTitle>C: creditworthiness...</SectionTitle>
        <h3 class="c-title-3--normal">creditworthiness</h3>
        <p>One word</p>

        <SectionTitle>E: email...</SectionTitle>
        <h3 class="c-title-3--normal">bank</h3>
        <p>email is not hyphenated</p>

        <SectionTitle>H: homebuyer, homeowner...</SectionTitle>
        <h3 class="c-title-3--normal">homebuyer</h3>
        <p>One word</p>
        <h3 class="c-title-3--normal">homeowner</h3>
        <p>One word</p>
        <h3 class="c-title-3--normal">homeownership</h3>
        <p>One word</p>

        <SectionTitle>I: Internet...</SectionTitle>
        <h3 class="c-title-3--normal">internet</h3>
        <p>Lowercase</p>

        <SectionTitle>L: log in, log out...</SectionTitle>
        <h3 class="c-title-3--normal">log in/log out</h3>
        <p>Two words when used as an action</p>
        <h3 class="c-title-3--normal">login/logout</h3>
        <p>One word when used as a noun or an adjective</p>

        <SectionTitle>M: mtb.com...</SectionTitle>
        <h3 class="c-title-3--normal">mtb.com</h3>
        <p>Do not use "www." when writing out the url</p>

        <SectionTitle>O: online, Online Banking...</SectionTitle>
        <h3 class="c-title-3--normal">online</h3>
        <p>One word, not hyphenated</p>
        <h3 class="c-title-3--normal">Online Banking</h3>
        <p>Capitalize both words when referring to the platform</p>

        <SectionTitle>P: password, Prime Rate...</SectionTitle>
        <h3 class="c-title-3--normal">password</h3>
        <p>Correct usage for login screens</p>
        <h3 class="c-title-3--normal">Prime Rate</h3>
        <p>Capitalize both words</p>

        <SectionTitle>U: User ID</SectionTitle>
        <h3 class="c-title-3--normal">User ID</h3>
        <p>Correct use for login screens</p>

        <SectionTitle>W: website, Wilmington Trust...</SectionTitle>
        <h3 class="c-title-3--normal">website</h3>
        <p>One word, lowercase</p>
        <h3 class="c-title-3--normal">Wilmington Trust</h3>
        <p>Always capitalized</p>
        <h3 class="c-title-3--normal">wilmingtontrust.com</h3>
        <p>Do not use "www." when writing out the url</p>

        <hr />
        <SectionTitle>Abbreviations</SectionTitle>
        <p>
          Only use the abbreviations below when UI space is limited. Otherwise
          always write out the full word.
        </p>

        <div class="l-flex-row l-margin-top--xxlarge">
          <div class="l-flex-col--xs-6">
            <h3 class="c-title-3--normal">Months</h3>
            <table>
              <th>Full</th>
              <th>Abbreviation</th>
              <tr>
                <td>January</td>
                <td>Jan</td>
              </tr>
              <tr>
                <td>February</td>
                <td>Feb</td>
              </tr>
              <tr>
                <td>March</td>
                <td>Mar</td>
              </tr>
              <tr>
                <td>April</td>
                <td>Apr</td>
              </tr>
              <tr>
                <td>May</td>
                <td>May</td>
              </tr>
              <tr>
                <td>June</td>
                <td>Jun</td>
              </tr>
              <tr>
                <td>July</td>
                <td>Jul</td>
              </tr>
              <tr>
                <td>August</td>
                <td>Aug</td>
              </tr>
              <tr>
                <td>September</td>
                <td>Sep</td>
              </tr>
              <tr>
                <td>October</td>
                <td>Oct</td>
              </tr>
              <tr>
                <td>November</td>
                <td>Nov</td>
              </tr>
              <tr>
                <td>December</td>
                <td>Dec</td>
              </tr>
            </table>
          </div>

          <div class="l-flex-col--xs-6">
            <h3 class="c-title-3--normal">Days</h3>
            <table>
              <th>Full</th>
              <th>Abbreviation</th>
              <tr>
                <td>Monday</td>
                <td>Mon</td>
              </tr>
              <tr>
                <td>Tuesday</td>
                <td>Tue</td>
              </tr>
              <tr>
                <td>Wednesday</td>
                <td>Wed</td>
              </tr>
              <tr>
                <td>Thursday</td>
                <td>Thu</td>
              </tr>
              <tr>
                <td>Friday</td>
                <td>Fri</td>
              </tr>
              <tr>
                <td>Saturday</td>
                <td>Sat</td>
              </tr>
              <tr>
                <td>Sunday</td>
                <td>Sun</td>
              </tr>
            </table>
          </div>
        </div>
      </Layout>
    </>
  )
}
